import { testimonials } from '@/mocks/testimonials';

const avatarUrls: Record<string, string> = {
  'avatar-01': 'https://readdy.ai/api/search-image?query=Mature%20man%20with%20silver%20hair%20and%20kind%20eyes%20wearing%20a%20navy%20polo%20shirt%2C%20warm%20studio%20lighting%2C%20ivory%20backdrop%2C%20wise%20and%20trustworthy%20expression&width=80&height=80&seq=avatar-t-v3-1&orientation=squarish',
  'avatar-02': 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20long%20dark%20hair%20and%20a%20radiant%20smile%2C%20casual%20cream%20sweater%2C%20soft%20diffused%20light%2C%20clean%20minimal%20backdrop%2C%20fresh%20natural%20look&width=80&height=80&seq=avatar-t-v3-2&orientation=squarish',
  'avatar-03': 'https://readdy.ai/api/search-image?query=Stylish%20man%20with%20tattooed%20arms%20in%20a%20black%20t-shirt%2C%20confident%20expression%2C%20dramatic%20side%20lighting%2C%20dark%20warm%20background%2C%20modern%20urban%20portrait&width=80&height=80&seq=avatar-t-v3-3&orientation=squarish',
  'avatar-04': 'https://readdy.ai/api/search-image?query=Professional%20woman%20with%20short%20blonde%20hair%20in%20a%20crisp%20white%20blouse%2C%20direct%20confident%20gaze%2C%20bright%20studio%20lighting%2C%20light%20grey%20backdrop&width=80&height=80&seq=avatar-t-v3-4&orientation=squarish',
  'avatar-05': 'https://readdy.ai/api/search-image?query=Friendly%20young%20man%20with%20curly%20brown%20hair%20and%20warm%20smile%20in%20a%20green%20hoodie%2C%20natural%20window%20light%2C%20relaxed%20portrait%2C%20soft%20cream%20background&width=80&height=80&seq=avatar-t-v3-5&orientation=squarish',
  'avatar-06': 'https://readdy.ai/api/search-image?query=Elegant%20woman%20with%20braided%20hair%20and%20gold%20earrings%2C%20warm%20confident%20smile%2C%20rich%20studio%20lighting%2C%20warm%20beige%20backdrop%2C%20refined%20portrait%20photography&width=80&height=80&seq=avatar-t-v3-6&orientation=squarish',
};

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-2 h-2 rounded-full bg-accent-500"></div>
          <span className="text-xs font-semibold uppercase tracking-widest text-secondary-600 whitespace-nowrap">Verified Reviews</span>
        </div>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
          What Shoppers Say
        </h2>
        <p className="text-foreground-500 text-sm mb-10 max-w-md">
          Real feedback from real users who rely on the AcBuy Spreadsheet every day for their shopping needs.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                  </div>
                ))}
              </div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">{t.title}</h4>
              <p className="text-foreground-500 text-sm leading-relaxed mb-4">{t.body}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/50">
                <div className="w-9 h-9 rounded-full bg-secondary-200 overflow-hidden flex-shrink-0">
                  <img
                    src={avatarUrls[t.avatarSeq] || avatarUrls['avatar-01']}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{t.name}</p>
                  <p className="text-xs text-foreground-400 whitespace-nowrap">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}